import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';

export default function AppInit() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    checkAppState();
  }, []);

  const checkAppState = async () => {
    try {
      const userRes = await api.get('/auth/me');
      const user = userRes.data;

      // Student accounts go directly to child home
      if (user.is_student_account && user.child_id) {
        navigate(`/child/${user.child_id}/home`, { replace: true });
        return;
      }
      if (user.is_student_account && !user.child_id) {
        navigate('/student/onboarding', { state: { user }, replace: true });
        return;
      }

      const childrenResponse = await api.get('/children');
      if (childrenResponse.data && childrenResponse.data.length > 0) {
        navigate('/family', { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    } catch (error) {
      navigate('/', { replace: true });
    } finally {
      setChecking(false);
    }
  };

  return (
    <div className="kid-layout min-h-screen flex items-center justify-center">
      <div className="text-center relative z-10">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-orange-400 mx-auto mb-4"></div>
        <p className="text-orange-600 text-lg font-semibold">Loading Yukti...</p>
      </div>
    </div>
  );
}
